import React, { useContext, useEffect, useState } from 'react'
import { GridColDef } from '@mui/x-data-grid'
import { Stack } from '@mui/material'
import { Row, sharedColDefs } from './supplierPageConstants'
import { FilterContext } from '../../../context/FilterContext'
import { SupplierPageDataGrid } from './SupplierPageDataGrid'
import { Body1 } from '../../../components/Typography'
import { useSupplierRows } from './useSupplierRows'
import { ErrorSnackBarContext } from '../../../context/ErrorSnackBarContex'
import { captureException } from '../../../utils/Sentry'
import { SnackAlert } from '../../../components/SnackAlert'

function NoResultRow() {
  return (
    <Stack height='100%' alignItems='center' justifyContent='center'>
      <Body1>Inga leverantörer matchar sökvillkoren</Body1>
    </Stack>
  )
}

const coldefs: GridColDef<Row>[] = [
  {
    field: 'name',
    headerName: 'Leverantörer',
    flex: 1,
  },
  // Include ID column for the supplier ID.
  {
    field: 'supplierId',
    headerName: 'ID',
    flex: 1,
  },
  ...sharedColDefs,
]

export function SupplierGrid(params: {
  selectedYear?: number
}): React.JSX.Element {
  const { selectedYear } = params

  const { orgUnit } = useContext(FilterContext)

  const { setError } = useContext(ErrorSnackBarContext)

  const [showHitRowLimit, setShowHitRowLimit] = useState(false)

  const { rows, data, loading, error } = useSupplierRows({
    selectedYear,
    selectedOrgUnit: orgUnit?.id,
  })

  useEffect(() => {
    // True if the query result was cut short by the server due to the
    // request hitting the row count limit.
    if (!loading && !!data?.aggregateBySupplier.limitedRows) {
      setShowHitRowLimit(true)
    }
  }, [loading, data?.aggregateBySupplier.limitedRows])

  useEffect(() => {
    if (error) {
      setError()
      captureException(error)
    }
  }, [error, setError])

  return (
    <>
      <SnackAlert
        open={showHitRowLimit}
        onClose={() => setShowHitRowLimit(false)}
        severity='warning'
      >
        Antalet rader i tabellen har begränsats då resultatet var för långt.
      </SnackAlert>

      <SupplierPageDataGrid
        coldefs={coldefs}
        rows={rows}
        loading={loading}
        NoSearchResult={NoResultRow}
      />
    </>
  )
}
